// extracted by mini-css-extract-plugin
module.exports = {"width-160":"_2xOvLg2iD7","width-430":"_2iXYvAGY8_","remark":"EQ4KKho_DV","reminder-block":"_2O5xc6RxQP","text-button":"_2y_x-ctlQn"};